<template>
  <el-container>
    <el-main :style="{ 'min-height': `${elementHeight}px` }">
    </el-main>
    <publicFooter></publicFooter>
    <publicMask :fullscreenLoading="fullscreenLoading"></publicMask>
  </el-container>
</template>
<script>
import {signIn} from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicMask from '@/components/public/publicMask'
export default {
  name: 'oneTouch',
  components: {
    publicFooter,
    publicMask
  },
  data () {
    return {
      fullscreenLoading: true,
      token: '',
      source: '',
      elementHeight: 500,
      search_json: {}
    }
  },
  created () {
    this.beforeMount()
  },
  mounted () {
    this.token = this.$route.query.userToken
    this.source = this.$route.query.source
    if (this.token === undefined || this.source === undefined) {
      localStorage.setItem('LoginWebsiteAddress', '')
      this.$router.push({name: 'login'})
    }
    this.oneTouch()
  },
  methods: {
    beforeMount () {
      this.elementHeight = document.documentElement.clientHeight || document.body.clientHeight
    },
    oneTouch () {
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {'userToken': this.token, 'time': time, 'source': this.source, 'operation': 'oneTouch'}
      var data = this.common.encryptionData(dataJson, this)

      signIn(data).then(res => {
        if (res.flag === '200') {
          localStorage.setItem('token', res.data.token)
          let source = res.data.source
          if (source !== '' && source !== undefined && source !== null) {
            this.source = source
            var sourceExpiresAt = Date.now() + 3600000 * 5
            localStorage.setItem('source', this.source)
            localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
          } else {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          }
          if (res.data.redirectPage !== 'HotelList') {
            this.$router.push({name: res.data.redirectPage, query: {'source': this.source}})
          } else {
            let d = new Date()
            var year = d.getFullYear()
            var month = d.getMonth()
            var tian = d.getDate()
            var dayNum = new Date(year, parseInt(month) + 1, 0).getDate()
            var startDate = tian
            var endDate = tian + 1
            var startMonth = month
            var endMonth = month
            var startYear = year
            var endYear = year
            if (startDate > dayNum) {
              startDate = parseInt(startDate) - parseInt(dayNum)
              startMonth += 1
            }
            if (endDate > dayNum) {
              endDate = parseInt(endDate) - parseInt(dayNum)
              endMonth += 1
            }
            if (startMonth >= 12) {
              startMonth = 0
              startYear += 1
            }
            if (endMonth >= 12) {
              endMonth = 0
              endYear += 1
            }
            var monthStartSelect = (startMonth + 1) < 10 ? '0' + (startMonth + 1).toString() : (startMonth + 1).toString()
            var monthEndSelect = (endMonth + 1) < 10 ? '0' + (endMonth + 1).toString() : (endMonth + 1).toString()
            var startDateSelect = startDate < 10 ? '0' + startDate.toString() : startDate.toString()
            var endDateSelect = endDate < 10 ? '0' + endDate.toString() : endDate.toString()
            let startDateInfo = startYear + '-' + monthStartSelect + '-' + startDateSelect
            let endDateInfo = endYear + '-' + monthEndSelect + '-' + endDateSelect

            this.search_json['start_date'] = startDateInfo
            this.search_json['end_date'] = endDateInfo
            this.search_json['room'] = 1
            this.search_json['adult'] = 2
            this.search_json['child'] = 0
            this.search_json['childNums'] = []
            this.search_json['type'] = this.common.defaultRegionType
            this.search_json['type_id'] = this.common.defaultRegionId
            this.search_json['region'] = this.common.defaultRegion
            this.search_json['source'] = source
            this.$router.push({name: 'HotelList', query: this.search_json})
          }
        } else {
          this.$router.push({name: 'login'})
        }
      })
    }
  }
}
</script>

<style scoped>
.el-main{background-color: rgba(242, 242, 242, 1);}
.login-main{background-color: rgba(242, 242, 242, 1);width:100%;padding-bottom:10px; margin:0 auto;height: 100vh;padding-top: 4%;}
.login-info{margin: 0 auto;background-color: rgba(255, 255, 255, 1);border: none;border-radius: 5px;}
.forgotpassword{color: rgba(2, 167, 240, 0.6);text-decoration: none;}
.login-form{margin:15px 0px; color:#606266;font-size: 14px;}
.login-form input{ margin-top:10px;}
/deep/ .el-button, .login_send{width: 140px;height: 40px; font-size:14px; background-color: rgba(83, 102, 163, 1);border: 1px solid rgba(83, 102, 163, 1);border-radius: 5px;color: #FFFFFF;}
/deep/ .login_send:hover{background-color: #FFF; border: 1px solid rgba(83, 102, 163, 1); color:rgba(83, 102, 163, 1);}
.marginTop40{margin-top: 40px;}
.marginTop35{margin-top: 35px;}
.marginTop25{margin-top: 25px;}
.marginTop15{margin-top: 15px;}
.marginTop10{margin-top: 10px;}
.marginLeft0{margin-left: 0px !important;}
.el-form-item__content{height: 40px;}
/deep/ .el-input__inner:focus{border-color:rgba(83, 102, 163, 1);box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
/deep/ .el-button:focus, .el-button:hover{width: 140px;height: 40px; font-size:14px;background-color: #FFF; border: 1px solid rgba(83, 102, 163, 1); color:rgba(83, 102, 163, 1);}

/*提示*/
.login-remind-notice{border-width: 0px;min-height: 56px;background: inherit;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remind-notice-text{line-height: 20px; font-size: 14px;font-weight: 400;color:#5392F9;display:inline-block;width:90%;margin-top:10px}
.login-remind-notice img {width: 18px;height: 18px;margin-right: 5px;}
/* 登录提醒 */
.login-remind{ border-width: 0px;height: 56px;background: inherit;background-color: rgba(240, 249, 235);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remindinfo{padding-right: 18px;display: flex;justify-content: center;align-items: center; line-height:56px;}
.login-img{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.login-remind-text{color: #67C23A;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
/* 失败 */
.login-remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.login-remind-text-faild{color: #FF001F;font-size: 10px;display: block;margin-top: -8px;}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.mybox-leave-active,
.mybox-enter-active {
  transition: all 1s ease;
}

.mybox-leave-active,
.mybox-enter {
  height: 0px !important;
}

.mybox-leave,
.mybox-enter-active {
  height: 56px;
}
@media screen and (min-width: 1001px) {
  .login-info{width: 520px;}
}
@media screen and (max-width: 1000px) {
  .login-info{width: 97%;}
}
</style>



// WEBPACK FOOTER //
// src/components/login/oneTouch.vue